module.exports = __webpack_public_path__ + "img/COMBO FLOWER RED.311efc7.svg";